export default "__VITE_ASSET__DFWZgGpq__"